/**
 * @param {string} strokeColor - '#rrggbb', '#rgb', 'rgb(...)', 'rgba(...)'
 * @param {{ lightness?: number, alpha?: number }} [opts]
 *   lightness 0–1: how much to mix toward white (default ~0.4)
 *   alpha 0–1: fill opacity (default ~0.35)
 * @returns {string} 'rgba(r,g,b,a)'
 */
export function strokeColorToFillColor(strokeColor, opts = {}) {
  const lightness = opts.lightness ?? 0.4;
  const alpha = opts.alpha ?? 0.35;

  let r;
  let g;
  let b;
  let strokeAlpha = 1;

  const s = String(strokeColor).trim();

  if (s.startsWith("#")) {
    let hex = s.slice(1);
    if (hex.length === 3) {
      hex = hex.split("").map((c) => c + c).join("");
    }
    if (hex.length !== 6) {
      return `rgba(133, 147, 146, ${alpha})`;
    }
    r = parseInt(hex.slice(0, 2), 16);
    g = parseInt(hex.slice(2, 4), 16);
    b = parseInt(hex.slice(4, 6), 16);
  } else {
    const m = s.match(
      /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(?:\s*,\s*([\d.]+))?\s*\)/i
    );
    if (!m) {
      return `rgba(133, 147, 146, ${alpha})`;
    }
    r = Number(m[1]);
    g = Number(m[2]);
    b = Number(m[3]);
    if (m[4] !== undefined) strokeAlpha = Number(m[4]);
  }

  const lr = Math.round(r + (255 - r) * lightness);
  const lg = Math.round(g + (255 - g) * lightness);
  const lb = Math.round(b + (255 - b) * lightness);
  const fillA = Math.min(1, alpha * strokeAlpha);

  return `rgba(${lr}, ${lg}, ${lb}, ${fillA})`;
}

export default strokeColorToFillColor;